export const environment = {
  production: false,
  ANGULAR_ENVIRONMENT: 'Environment',
  apiBaseUrl: 'https://web-trex-dev-api.azurewebsites.net/api',
  baseUrl: 'https://web-trex-dev-fe.azurewebsites.net',
};
export { userRoles } from './user-roles';

export const calendarevent = {
  "status": true,
  "message": "Events retrieved successfully.",
  "data": [
    {
      "eventId": "1eabd76f-bfc2-4f3c-9e73-a6dfcad50775",
      "eventName": "SPC 9201",
      "description": null,
      "eventTypeId": "f095ebf1-179d-f011-b483-000d3acacfee",
      "eventTypeName": "WorldSkills Try A Trade",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-20T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": null,
      "audienceTypeId": "47e1937a-30f9-48c6-b099-db7540a6e873",
      "audienceTypeName": "testaudience71202600",
      "eventHostRegionId": "683dcd5f-63f0-4fb8-962b-1472971c5468",
      "eventHostRegionName": "Metropolitan",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "0498e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Infrastructure (Civil)",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "2a83c7ed-2399-41b9-db64-08de2b083748",
          "userId": "2bff575e-8f1a-4134-23cb-08de2ab5703d",
          "firstName": "Ranjeeta",
          "lastName": "Singh",
          "email": "ranjeeta.singh+9@csq.org.au",
          "mobileNumber": "0488888888",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "20 members",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": true,
      "eventStatusId": "25c4ae77-bbca-f011-8195-002248117e03",
      "eventStatus": "Draft",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "1bf03a2a-e6c0-4e0e-9035-b7e43f0352d9",
      "eventName": "Testdarft123",
      "description": "For testing",
      "eventTypeId": "c148e9da-46f0-f011-8195-002248962eb2",
      "eventTypeName": "TestEventType13-01-2026",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 3,
      "eventTime": "12:00 PM to 1:22 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": true,
      "eventStatusId": "25c4ae77-bbca-f011-8195-002248117e03",
      "eventStatus": "Draft",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "2981b8de-4eb4-498f-9b17-2d4b06758c89",
      "eventName": ".",
      "description": null,
      "eventTypeId": "fae3c304-56cb-f011-8195-002248117e03",
      "eventTypeName": "Virtual Reality",
      "eventStartDate": "2026-01-24T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 1,
      "eventTime": "4:04 AM to 4:04 PM",
      "location": "b",
      "audienceTypeId": "d93dd561-3c67-43e5-bb95-6a2c118c472f",
      "audienceTypeName": "Sports Clubs",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "1a883756-04f8-f011-832e-002248121f7b",
          "userId": "cf89aa5b-4a09-4b1a-2abe-08de5a283ae1",
          "firstName": "Joseph",
          "lastName": "Woo",
          "email": "joseph.wong+99@csq.org.au",
          "mobileNumber": "0412345678",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "7e79487d-45a8-4048-9685-511d0863d3f5",
      "eventName": "Testeveaant23-01-2026",
      "description": "For Testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-24T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 1:00AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/student-external-events/student_event_7e79487d-45a8-4048-9685-511d0863d3f5_1fdc3ac6-86bb-48f0-ae22-c2742a39bf16.png"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "e5a8ac1d-649e-4fe0-ae50-9e336819d792",
      "eventName": ".",
      "description": null,
      "eventTypeId": "e695ebf1-179d-f011-b483-000d3acacfee",
      "eventTypeName": "Try A Trade",
      "eventStartDate": "2026-01-25T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "3:50 AM to 3:50 PM",
      "location": "M",
      "audienceTypeId": "d93dd561-3c67-43e5-bb95-6a2c118c472f",
      "audienceTypeName": "Sports Clubs",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "1a883756-04f8-f011-832e-002248121f7b",
          "userId": "cf89aa5b-4a09-4b1a-2abe-08de5a283ae1",
          "firstName": "Joseph",
          "lastName": "Woo",
          "email": "joseph.wong+99@csq.org.au",
          "mobileNumber": "0412345678",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "db968e4b-5b27-43cf-9819-42f125b021de",
      "eventName": "Testevent23-01-20269",
      "description": "For testing",
      "eventTypeId": "71a41fbf-44cc-f011-8195-002248117e03",
      "eventTypeName": "AJS Events",
      "eventStartDate": "2026-01-24T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "d93dd561-3c67-43e5-bb95-6a2c118c472f",
      "audienceTypeName": "Sports Clubs",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": true,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "90ecae47-6bf7-f011-832e-002248121f7b",
          "focusAreaName": "test-9-10-2025 -",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "615fea83-9ac0-45de-62f9-08de3a14164e",
          "userId": "4b604008-b15e-44d7-870a-08de3a0dfbb5",
          "firstName": "SahalCSQAdmintest100",
          "lastName": "PS",
          "email": "sahal.g3interactive+Admincsq@gmail.com",
          "mobileNumber": "0469856974",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "fddf97ef-53f5-43d8-b530-ff8e66f99fb1",
      "eventName": "Testevent23-01-2026",
      "description": "For testing",
      "eventTypeId": "3f825179-66e5-f011-8195-002248117e03",
      "eventTypeName": "TX",
      "eventStartDate": "2026-01-24T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "f5cc1456-8e95-4f6d-aa94-f377ba00ad1d",
      "audienceTypeName": "Teachers",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": true,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "90ecae47-6bf7-f011-832e-002248121f7b",
          "focusAreaName": "test-9-10-2025 -",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "3c3800b8-dbd0-f011-8195-002248117e03",
          "userId": "e3f1c7b1-a62b-4cc8-9ab8-4487d03d2534",
          "firstName": "Ranjeeta",
          "lastName": "Singh (CSQ Admin)",
          "email": "ranjeeta.singh@csq.org.au",
          "mobileNumber": "0456789209",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "65179b5f-02ed-40bc-1048-08de2afc8729",
          "mccEventPartnerName": "John Howard Builders",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": true,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": "1212909472677100",
      "asanaLastSyncedAt": "2026-01-23T04:28:58.1535228",
      "asanaSyncedByUserName": "Sahal CSQAdmin",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "81f66958-53e7-459c-a31e-034f8b5805cb",
      "eventName": "Test Teacher Email Send",
      "description": null,
      "eventTypeId": "fae3c304-56cb-f011-8195-002248117e03",
      "eventTypeName": "Virtual Reality",
      "eventStartDate": "2026-01-24T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:57 AM to 12:58 PM",
      "location": "Bris",
      "audienceTypeId": "adf1c4dd-0f9d-f011-b483-000d3acacfee",
      "audienceTypeName": "High School Students",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "0498e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Infrastructure (Civil)",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "c348bb85-caf7-43cd-e627-08de1c0f35a5",
          "userId": "3fd72fcd-f1c2-4cb9-985f-08de1c0dbed7",
          "firstName": "Joseph",
          "lastName": "Wong",
          "email": "joseph.wong@csq.org.au",
          "mobileNumber": "+61 406197728",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "N/A",
      "participantsAndSupervisors": "20",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "695adbec-7aed-4ed6-79a7-08de31706810",
          "schoolName": "Joseph Senior High",
          "isMou": true,
          "teachers": [
            {
              "userId": "021190e6-9df5-4923-a7c8-08de3170d9de",
              "firstName": "J",
              "lastName": "W",
              "email": "joseph.wong+20@csq.org.au",
              "mobileNumber": "+61400400400",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "a6fa1aa6-9fa7-4981-8c5a-8ad28d9ef69d",
      "eventName": "Saran Teacher Event 21/26",
      "description": "Bricklaying",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 0,
      "eventTime": "5:00 PM to 9:00 PM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/teacher-events/teacher_event_a6fa1aa6-9fa7-4981-8c5a-8ad28d9ef69d_216fe821-400e-497f-8a55-b14528aa9a14.jpg"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "3892530a-f844-42c0-70ce-08de36454334",
          "schoolName": "AUS Public School",
          "isMou": true,
          "teachers": [
            {
              "userId": "01c8defc-dc79-4f0f-4c8f-08de364567f1",
              "firstName": "CSQ",
              "lastName": "Teacher",
              "email": "jaisaran.g3interactive+teach@gmail.com",
              "mobileNumber": "0485200087",
              "profilePicture": "https://storcsqtrexdev.blob.core.windows.net/trex-images/profile-pictures/0e5a7e91-f4ce-483b-a2f1-db194b7e73bb.jpg"
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "222764f1-da19-4b1b-a8a7-21222cdbb93e",
      "eventName": "testconsent-above16",
      "description": "0e7c8662-cdaf-4b57-94d0-48daeb5e74b0",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-23T00:00:00",
      "eventEndDate": "2026-01-30T00:00:00",
      "noOfDays": 0,
      "eventTime": "4:39 PM to 7:39 PM",
      "location": "wsfw",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "1f13d5b7-18df-f011-8195-002248117e03",
          "schoolName": "CKD school",
          "isMou": true,
          "teachers": [
            {
              "userId": "7243be8d-dd65-43ce-a5a6-08de2822981d",
              "firstName": "Deep",
              "lastName": "Teacher",
              "email": "mandeep.singh+3@csq.org.au",
              "mobileNumber": "0400020021",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "71a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Upcoming",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "cdfa6e5d-08fa-4c67-825f-1745a8d6802a",
      "eventName": "Work Experience",
      "description": null,
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-23T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 2,
      "eventTime": "8:00AM to 9:00AM",
      "location": "dfghjgokb",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "881a3556-fd1a-4904-849e-b237118f3ca2",
      "eventName": "Work Experience",
      "description": "Bricklaying",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-26T00:00:00",
      "noOfDays": 2,
      "eventTime": "5:30 AM to 6:30 PM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/teacher-events/teacher_event_881a3556-fd1a-4904-849e-b237118f3ca2_ac75b12b-64f3-48c7-950f-abdddb6fb38c.jpg"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "01c8defc-dc79-4f0f-4c8f-08de364567f1",
              "firstName": "CSQ",
              "lastName": "Teacher",
              "email": "jaisaran.g3interactive+teach@gmail.com",
              "mobileNumber": "0485200087",
              "profilePicture": "https://storcsqtrexdev.blob.core.windows.net/trex-images/profile-pictures/0e5a7e91-f4ce-483b-a2f1-db194b7e73bb.jpg"
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "4499dc38-15cd-4470-b476-2a2e01cf2b3d",
      "eventName": "Event Duplicate Test",
      "description": "Testing",
      "eventTypeId": "71a41fbf-44cc-f011-8195-002248117e03",
      "eventTypeName": "AJS Events",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-31T00:00:00",
      "noOfDays": 1,
      "eventTime": "1:01 AM to 12:12 PM",
      "location": "Test",
      "audienceTypeId": "d93dd561-3c67-43e5-bb95-6a2c118c472f",
      "audienceTypeName": "Sports Clubs",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": true,
      "busRequired": true,
      "additionalRequirements": "PPE",
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_4499dc38-15cd-4470-b476-2a2e01cf2b3d_d31a984a-84b9-4392-93f7-b98d6934e544.jpg",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_4499dc38-15cd-4470-b476-2a2e01cf2b3d_c01fce9e-4e26-4c07-83f6-6b6c2a0515fb.jpg",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_4499dc38-15cd-4470-b476-2a2e01cf2b3d_3bd7f5e0-9101-410a-83f0-47d48a43fc70.jpg",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_4499dc38-15cd-4470-b476-2a2e01cf2b3d_3eb2982f-54c4-46b5-b643-aad3f38fb5cf.jpg",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_4499dc38-15cd-4470-b476-2a2e01cf2b3d_77d0c9a8-c969-4983-a4e3-1bbf92d0c5da.jpg"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "97f22980-2d9b-4ff0-9e16-94b524ea27b3",
          "focusAreaName": "",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "e5f53320-8f04-46f8-11bf-08de2e494c71",
          "userId": "2710396c-43d0-4783-5143-08de2dbfac11",
          "firstName": "Anto",
          "lastName": "CSQ Team",
          "email": "anto.g3interactive+csqteam@gmail.com",
          "mobileNumber": "0454587844",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "CSK",
      "participantsAndSupervisors": "10,1",
      "isCsqFunded": true,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "aed4667b-1030-4f81-5140-08de2dbfac11",
              "firstName": "Anto",
              "lastName": "Teacher",
              "email": "antoarul2022@yahoo.com",
              "mobileNumber": "0412345678",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "a0ac3ad3-5439-4b07-b9a8-16995857ef04",
      "eventName": "Work Experience",
      "description": "Electrical",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-23T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 2,
      "eventTime": "8:00 AM to 9:00 PM",
      "location": "nfgnbmnb",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "dc8f72e5-3b0f-4ffd-3f5d-08de2c15f429",
          "schoolName": "TestSchool",
          "isMou": true,
          "teachers": [
            {
              "userId": "4c5dead5-696d-44d2-5af9-08de2cb16c27",
              "firstName": "Namitha",
              "lastName": "MV",
              "email": "namitha.g3interactive+teacher@gmail.com",
              "mobileNumber": "9745465535",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "a64afa55-10fc-455a-a128-c0ee0ebad2a3",
      "eventName": "Work Experience",
      "description": "Bricklaying",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "11:17 AM to 12:17 PM",
      "location": "brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "b8c1c255-07f5-f011-832e-002248121f7b",
          "schoolName": "RCUPS-1",
          "isMou": true,
          "teachers": [
            {
              "userId": "d8b421e6-b686-4932-7a8e-08de595fcd12",
              "firstName": "sana",
              "lastName": "shukkur",
              "email": "ishtechdeveloper10+rcup@gmail.com",
              "mobileNumber": "0423424234",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "e20482f0-a9a9-4da0-9d49-e13409cec76c",
      "eventName": "StudentSubmit22-01-2026",
      "description": "For Testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-23T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 1:00AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/student-external-events/student_event_e20482f0-a9a9-4da0-9d49-e13409cec76c_9b5de1dc-a69f-40db-b499-968603ae93fb.png"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "9c16edc3-7955-46eb-8d49-b481464ba2d3",
      "eventName": "Work Experience22-01-2026",
      "description": "Cabinetmaking",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-23T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "60a0b7ff-e3f5-f011-832e-002248121f7b",
          "schoolName": "Testschool20-01-2026",
          "isMou": false,
          "teachers": [
            {
              "userId": "8e314c12-4b7c-4afc-54a3-08de5807e4a2",
              "firstName": "Testteacher99",
              "lastName": "PS",
              "email": "sahal.g3interactive+testteacher9920@gmail.com",
              "mobileNumber": "0789658955",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "dca1caed-fad0-4985-8ad5-a8d1627b26fd",
      "eventName": "Work Experience-500",
      "description": null,
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-23T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "10:17 AM to 8:20 AM",
      "location": "test",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "b8c1c255-07f5-f011-832e-002248121f7b",
          "schoolName": "RCUPS-1",
          "isMou": true,
          "teachers": [
            {
              "userId": "d8b421e6-b686-4932-7a8e-08de595fcd12",
              "firstName": "sana",
              "lastName": "shukkur",
              "email": "ishtechdeveloper10+rcup@gmail.com",
              "mobileNumber": "0423424234",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "098903a0-6caa-4476-a304-19bd8d2ef669",
      "eventName": "Work Experience 22-01-2026",
      "description": "For Testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-23T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 1,
      "eventTime": "9:08AM to 12:08PM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/student-external-events/student_event_098903a0-6caa-4476-a304-19bd8d2ef669_653ca284-76a9-4e26-a897-2d2fc89e63cd.png"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "60d07572-291b-48b6-8ab8-3eba83ba871d",
      "eventName": "DRaft-Event-2",
      "description": null,
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "9:49 AM to 7:51 AM",
      "location": "test",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "6c7a0149-ddf6-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-5564-46",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "5e8d8f72-15f2-f011-8195-002248962eb2",
          "userId": "e86a4ea4-c19b-4add-1eb5-08de542c8ee1",
          "firstName": "admin",
          "lastName": "1",
          "email": "ishtechdeveloper10+csqadmin@gmail.com",
          "mobileNumber": "0423424234",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "test",
      "participantsAndSupervisors": "test",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "b8160ef2-de2f-43cc-a5a7-08de2822981d",
              "firstName": "sana",
              "lastName": "shukkur teacher",
              "email": "sana.g3interactive+teacher@gmail.com",
              "mobileNumber": "+61499123456",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "39d46a17-005c-4611-b710-0b593dafefd0",
          "mccEventPartnerName": "Testpartner18-01-2026",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "6a514a2d-9e7e-4a1e-834a-57a4b903aa3a",
      "eventName": "Drafted Event-TEsting",
      "description": null,
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "8:39 AM to 7:42 AM",
      "location": "test",
      "audienceTypeId": "47e1937a-30f9-48c6-b099-db7540a6e873",
      "audienceTypeName": "testaudience71202600",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "6c7a0149-ddf6-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-5564-46",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "185856a5-19b8-4b72-cf94-08de39680623",
          "userId": "73f5b846-d7cb-4a8b-969f-08de39680614",
          "firstName": "Sana",
          "lastName": "CSQAdmin",
          "email": "sana+csqadmin@ishtechnologies.com.au",
          "mobileNumber": "0412365789",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "test",
      "participantsAndSupervisors": "test",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "b8160ef2-de2f-43cc-a5a7-08de2822981d",
              "firstName": "sana",
              "lastName": "shukkur teacher",
              "email": "sana.g3interactive+teacher@gmail.com",
              "mobileNumber": "+61499123456",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "39d46a17-005c-4611-b710-0b593dafefd0",
          "mccEventPartnerName": "Testpartner18-01-2026",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "92bba8a7-0fa0-4faf-8c65-c7597f938138",
      "eventName": "Testevent6644",
      "description": "For testing",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "95d80d69-28f5-f011-832e-002248121f7b",
          "focusAreaName": "focusarea-1901",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            },
            {
              "userId": "29d0423a-b2f1-4381-b3d2-08de30c26d48",
              "firstName": "Testteacher19",
              "lastName": "RS",
              "email": "sahal.g3interactive+testteacher19@gmail.com",
              "mobileNumber": "0469856321",
              "profilePicture": ""
            },
            {
              "userId": "bde7bcf7-713a-46ff-8706-08de3a0dfbb5",
              "firstName": "Testteacherckd101",
              "lastName": "PS",
              "email": "sahal.g3interative+testtesacherCKD101@gmail.com",
              "mobileNumber": "0496589652",
              "profilePicture": ""
            },
            {
              "userId": "51f390bf-771a-4f8d-e825-08de2ce326b5",
              "firstName": "TestTeacherCKD100",
              "lastName": "Teacher",
              "email": "sahal.g3interactive+testTeacherCKD100@gmail.com",
              "mobileNumber": "0499999999",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "3d66d950-4abc-4695-bcc4-5cc089516bec",
      "eventName": "Naveen paul event 21",
      "description": "test",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-26T00:00:00",
      "noOfDays": 0,
      "eventTime": "7:00AM to 9:00PM",
      "location": "Kallor",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/student-external-events/student_event_3d66d950-4abc-4695-bcc4-5cc089516bec_e2e24eba-07e8-4b37-958e-5a86612c13f8.png"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "8775c0bd-be2b-4521-8b2f-f3da606ffe46",
      "eventName": "dasdsa",
      "description": "dasdas",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-28T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "dasdas",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "490940d0-29f5-f011-832e-002248121f7b",
          "focusAreaName": "focusarea20-56-2035",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "5e8d8f72-15f2-f011-8195-002248962eb2",
          "userId": "e86a4ea4-c19b-4add-1eb5-08de542c8ee1",
          "firstName": "admin",
          "lastName": "1",
          "email": "ishtechdeveloper10+csqadmin@gmail.com",
          "mobileNumber": "0423424234",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "0de7bfbe-4572-45ae-bea5-8a417797e1c8",
      "eventName": "Saran stu dev ",
      "description": "test",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 0,
      "eventTime": "9:39PM to 10:38PM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/student-external-events/student_event_0de7bfbe-4572-45ae-bea5-8a417797e1c8_02e775f8-ccd0-4898-9238-a18b796b65a3.jpg"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "d7a86832-b396-40ec-aadb-dcf8b392bdb9",
      "eventName": "dasd",
      "description": "das",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-27T00:00:00",
      "noOfDays": 1,
      "eventTime": "11:00 AM to 2:00 PM",
      "location": "sdf",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "055b241c-4d7f-4887-9de3-ad0ab0d8a65a",
      "eventHostRegionName": "TestEvent018-01-2026",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "490940d0-29f5-f011-832e-002248121f7b",
          "focusAreaName": "focusarea20-56-2035",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "5e8d8f72-15f2-f011-8195-002248962eb2",
          "userId": "e86a4ea4-c19b-4add-1eb5-08de542c8ee1",
          "firstName": "admin",
          "lastName": "1",
          "email": "ishtechdeveloper10+csqadmin@gmail.com",
          "mobileNumber": "0423424234",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "0e8946c0-3557-48e8-b419-fdf4a1e02b0f",
      "eventName": "Saran dev  test",
      "description": "Bricklaying",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 0,
      "eventTime": "5:00 PM to 9:00 PM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/teacher-events/teacher_event_0e8946c0-3557-48e8-b419-fdf4a1e02b0f_e7a90a81-88e8-4612-8c16-7d483ffad6a6.jpg"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "01c8defc-dc79-4f0f-4c8f-08de364567f1",
              "firstName": "CSQ",
              "lastName": "Teacher",
              "email": "jaisaran.g3interactive+teach@gmail.com",
              "mobileNumber": "0485200087",
              "profilePicture": "https://storcsqtrexdev.blob.core.windows.net/trex-images/profile-pictures/0e5a7e91-f4ce-483b-a2f1-db194b7e73bb.jpg"
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "515ba9c1-14c6-4fa1-ad93-eacad5c060ff",
      "eventName": "CSQ Event Notification",
      "description": "Email Test",
      "eventTypeId": "71a41fbf-44cc-f011-8195-002248117e03",
      "eventTypeName": "AJS Events",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-30T00:00:00",
      "noOfDays": 1,
      "eventTime": "1:01 AM to 12:12 PM",
      "location": "Marthandam",
      "audienceTypeId": "b9a21325-2baa-43a1-8d3d-12ef3d59fe55",
      "audienceTypeName": "Career Seekers",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": true,
      "busRequired": true,
      "additionalRequirements": "PPE",
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_515ba9c1-14c6-4fa1-ad93-eacad5c060ff_080ddc00-18db-41e5-9f57-8d19d21b9495.png"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "0598e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Renewables",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "97f22980-2d9b-4ff0-9e16-94b524ea27b3",
          "focusAreaName": "",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "cb6d0abf-a7e3-4512-3c8d-08de30b3eaa0",
          "userId": "d3e44739-559e-4104-27ba-08de30af3155",
          "firstName": "Anto",
          "lastName": "CSQ Admin Tester",
          "email": "anto.g3interactive+CSQAdmin@gmail.com",
          "mobileNumber": "0412345678",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "CSK",
      "participantsAndSupervisors": "22 Players, 2 On Field Referee",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 3,
      "collaborationTypeName": "Both",
      "collaboratingWithNonMcc": "Anto Non-MCC Partner",
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "39f42290-a99e-4da1-242d-08de1b8f4ae0",
              "firstName": "savad",
              "lastName": "Teacher",
              "email": "savad.g3interactive+teacher@gmail.com",
              "mobileNumber": "+61423456789",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "1382e93c-253d-4fc1-3244-08de33b3634d",
          "mccEventPartnerName": "Anto MCC Partner",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "856c80e8-6c47-46eb-a4dd-9618087be1fc",
      "eventName": "TestEvent21-01-2026",
      "description": "For Testing",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0a1e5737-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-55-2034",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "b38fb8ac-70f2-4924-829f-fc5f6bba39d8",
          "mccEventPartnerName": "testpa9",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "cace8e73-bdd2-4a90-9afc-36c1bcdd404e",
      "eventName": "Work Experience99",
      "description": "For testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 1:00AM",
      "location": "brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "8ba94067-bc9e-480c-ba93-c240f8ff3a4e",
      "eventName": "Testeventdraft21-01-2026",
      "description": "For Testing",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_8ba94067-bc9e-480c-ba93-c240f8ff3a4e_62d9d2c0-cfba-4c9a-a506-b0096d308140.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_8ba94067-bc9e-480c-ba93-c240f8ff3a4e_3265c545-e494-4419-b327-fe7c775825ee.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_8ba94067-bc9e-480c-ba93-c240f8ff3a4e_f2d052e5-1253-46b7-ba98-04e64727f42e.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_8ba94067-bc9e-480c-ba93-c240f8ff3a4e_abc3f7f9-adc8-4179-a0ae-80630a7bc242.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_8ba94067-bc9e-480c-ba93-c240f8ff3a4e_d50cdcc9-5594-4cb1-bfbe-4c49368a25fe.png"
      ],
      "focusAreas": [
        {
          "focusAreaId": "8dce95ae-29f5-f011-832e-002248121f7b",
          "focusAreaName": "area--9-5-13434",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "sasad",
      "participantsAndSupervisors": "asd",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "695adbec-7aed-4ed6-79a7-08de31706810",
          "schoolName": "Joseph Senior High",
          "isMou": true,
          "teachers": [
            {
              "userId": "f8f11060-63f2-4a2d-3718-08de2a6b4361",
              "firstName": "Markw",
              "lastName": "Thompson",
              "email": "jaisaran.g3interactive+12345@gmail.com",
              "mobileNumber": "0482930333",
              "profilePicture": "https://storcsqtrexdev.blob.core.windows.net/trex-images/profile-pictures/33dd91cb-c806-4b98-8239-15f4e2e6d5e6.jpg"
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "e20a8662-8ecb-48ba-8c01-67340ca4058a",
      "eventName": "TesteventDraft",
      "description": "For Testing",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_e20a8662-8ecb-48ba-8c01-67340ca4058a_571ac1ce-1e4d-4514-b87a-003fc762ffda.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_e20a8662-8ecb-48ba-8c01-67340ca4058a_9b541125-e9f4-41d9-9785-c4be22b8fb3b.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_e20a8662-8ecb-48ba-8c01-67340ca4058a_5960e74f-b45a-407a-a687-cb13571727e4.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_e20a8662-8ecb-48ba-8c01-67340ca4058a_431377d0-f403-4558-9061-05a497ef60fd.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_e20a8662-8ecb-48ba-8c01-67340ca4058a_ae3246f4-a19a-4acf-a086-3b34f25be6c1.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_e20a8662-8ecb-48ba-8c01-67340ca4058a_b09f4ecd-c546-45b8-8fcb-c7726de44e18.png"
      ],
      "focusAreas": [
        {
          "focusAreaId": "505f44f8-3ef4-f011-832e-002248121f7b",
          "focusAreaName": "Focus area 18-01-2026",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "615fea83-9ac0-45de-62f9-08de3a14164e",
          "userId": "4b604008-b15e-44d7-870a-08de3a0dfbb5",
          "firstName": "SahalCSQAdmintest100",
          "lastName": "PS",
          "email": "sahal.g3interactive+Admincsq@gmail.com",
          "mobileNumber": "0469856974",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "sports",
      "participantsAndSupervisors": "test",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "1f889214-44f4-f011-832e-002248121f7b",
          "schoolName": "Testschool001018-01-2026",
          "isMou": true,
          "teachers": [
            {
              "userId": "cf659ff7-e8bd-4b27-115d-08de55b67c36",
              "firstName": "Testteacher188",
              "lastName": "Ps",
              "email": "sahal.g3interactive+testteacher18888@gmail.com",
              "mobileNumber": "0489658999",
              "profilePicture": ""
            }
          ]
        },
        {
          "schoolId": "695adbec-7aed-4ed6-79a7-08de31706810",
          "schoolName": "Joseph Senior High",
          "isMou": true,
          "teachers": [
            {
              "userId": "f8f11060-63f2-4a2d-3718-08de2a6b4361",
              "firstName": "Markw",
              "lastName": "Thompson",
              "email": "jaisaran.g3interactive+12345@gmail.com",
              "mobileNumber": "0482930333",
              "profilePicture": "https://storcsqtrexdev.blob.core.windows.net/trex-images/profile-pictures/33dd91cb-c806-4b98-8239-15f4e2e6d5e6.jpg"
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "1f61c39f-ac84-4309-bb83-9a33b154761a",
      "eventName": "Work Experience21-01-2026",
      "description": "For Testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 1:00AM",
      "location": "brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/student-external-events/student_event_1f61c39f-ac84-4309-bb83-9a33b154761a_c443db39-c722-4596-a9a1-2acdbdcce2af.png"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "6de54200-5d85-456e-8af8-b267185d33b9",
      "eventName": "Work Experience",
      "description": "Cabinetmaking",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "60a0b7ff-e3f5-f011-832e-002248121f7b",
          "schoolName": "Testschool20-01-2026",
          "isMou": false,
          "teachers": [
            {
              "userId": "8e314c12-4b7c-4afc-54a3-08de5807e4a2",
              "firstName": "Testteacher99",
              "lastName": "PS",
              "email": "sahal.g3interactive+testteacher9920@gmail.com",
              "mobileNumber": "0789658955",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "988f1662-47d2-40b1-8a28-db2bdfbe2559",
      "eventName": "Asana Duplicate Test (Updated)",
      "description": "New",
      "eventTypeId": "eb95ebf1-179d-f011-b483-000d3acacfee",
      "eventTypeName": "Construction Chat",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 1,
      "eventTime": "1:01 AM to 12:12 PM",
      "location": "Kaloor",
      "audienceTypeId": "b9a21325-2baa-43a1-8d3d-12ef3d59fe55",
      "audienceTypeName": "Career Seekers",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": true,
      "busRequired": true,
      "additionalRequirements": "PPE",
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_988f1662-47d2-40b1-8a28-db2bdfbe2559_5fc66189-4773-4309-b106-a4a11fdc0840.png"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "97f22980-2d9b-4ff0-9e16-94b524ea27b3",
          "focusAreaName": "",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "3c3800b8-dbd0-f011-8195-002248117e03",
          "userId": "e3f1c7b1-a62b-4cc8-9ab8-4487d03d2534",
          "firstName": "Ranjeeta",
          "lastName": "Singh (CSQ Admin)",
          "email": "ranjeeta.singh@csq.org.au",
          "mobileNumber": "0456789209",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "CSK",
      "participantsAndSupervisors": "20,4",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 3,
      "collaborationTypeName": "Both",
      "collaboratingWithNonMcc": "Testing",
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "aed4667b-1030-4f81-5140-08de2dbfac11",
              "firstName": "Anto",
              "lastName": "Teacher",
              "email": "antoarul2022@yahoo.com",
              "mobileNumber": "0412345678",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "1382e93c-253d-4fc1-3244-08de33b3634d",
          "mccEventPartnerName": "Anto MCC Partner",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": true,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": "1212877451435678",
      "asanaLastSyncedAt": "2026-01-20T11:15:35.5420475",
      "asanaSyncedByUserName": "Anto CSQ Admin Tester",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "af00f673-6a68-41fe-a1ea-8ff3af30e948",
      "eventName": "TestEvent",
      "description": "For Testing",
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 9:09 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "490940d0-29f5-f011-832e-002248121f7b",
          "focusAreaName": "focusarea20-56-2035",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "259d0d4b-4d05-4540-96cd-780306e0fa26",
      "eventName": "Testevent20012026",
      "description": "For Testing",
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 1,
      "eventTime": "9:06 AM to 6:06 AM",
      "location": "Brisbane00",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": true,
      "busRequired": false,
      "additionalRequirements": "ppp",
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0a1e5737-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-55-2034",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "04a91a8d-29f5-f011-832e-002248121f7b",
          "focusAreaName": "focus aread-1000-24",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "615fea83-9ac0-45de-62f9-08de3a14164e",
          "userId": "4b604008-b15e-44d7-870a-08de3a0dfbb5",
          "firstName": "SahalCSQAdmintest100",
          "lastName": "PS",
          "email": "sahal.g3interactive+Admincsq@gmail.com",
          "mobileNumber": "0469856974",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "39d46a17-005c-4611-b710-0b593dafefd0",
          "mccEventPartnerName": "Testpartner18-01-2026",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        },
        {
          "mccEventPartnerId": "14f69fbf-284f-4d5b-8755-a7f3c8d45eb2",
          "mccEventPartnerName": "Event partner-1",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "096c83ae-7e4a-484d-802d-0a1b77d961b3",
      "eventName": "Test draft 099",
      "description": null,
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "Brisbane",
      "audienceTypeId": "9f5e0d8a-3920-4937-be46-90c2be79cd48",
      "audienceTypeName": "G3 Team",
      "eventHostRegionId": "d85c05ae-299d-f011-b483-000d3acacfee",
      "eventHostRegionName": "Sunshine Coast",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_096c83ae-7e4a-484d-802d-0a1b77d961b3_a93511bc-365b-4d13-98a5-c1f990fa0bd2.png"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0aec72a2-c3ea-45ea-3d10-08de2a6b4368",
          "userId": "c1bb7739-c153-4a3c-370c-08de2a6b4361",
          "firstName": "John",
          "lastName": "Mathews",
          "email": "john.mathews@example.com",
          "mobileNumber": "9876543200",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "nopw",
      "participantsAndSupervisors": "csd",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "693aff1b-ada2-4ac9-fab4-08de109ceaf5",
          "schoolName": "ABC school",
          "isMou": true,
          "teachers": [
            {
              "userId": "4901d75a-570f-4060-6d32-08de3070daaa",
              "firstName": "Sarah",
              "lastName": "hehehehe",
              "email": "caitlin.belgrove+1@csq.org.au",
              "mobileNumber": "0429158134",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "6caff91d-b4f7-400c-aec5-23ad57ef5f1a",
      "eventName": "test event",
      "description": null,
      "eventTypeId": "f195ebf1-179d-f011-b483-000d3acacfee",
      "eventTypeName": "Teacher PD",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-26T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "Brisbane",
      "audienceTypeId": "b9a21325-2baa-43a1-8d3d-12ef3d59fe55",
      "audienceTypeName": "Career Seekers",
      "eventHostRegionId": "d45c05ae-299d-f011-b483-000d3acacfee",
      "eventHostRegionName": "GREATER BRISBANE",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_6caff91d-b4f7-400c-aec5-23ad57ef5f1a_b5494d17-34e8-47cc-a3be-1b5cd892f519.jpg"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "8ff0e10c-b53a-4042-164f-08de3070dab6",
          "userId": "a3b9f066-aeb7-4dc0-6d2a-08de3070daaa",
          "firstName": "Tony",
          "lastName": "Martin",
          "email": "Tony.Martin@csq.org.au",
          "mobileNumber": "0466666666",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "nn",
      "participantsAndSupervisors": "nn",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "803132d3-1d9d-f011-b483-000d3acacfee",
          "schoolName": "Kelvin Grove State College",
          "isMou": true,
          "teachers": [
            {
              "userId": "6d9999b4-6fc3-400f-9917-08de529a0062",
              "firstName": "Matt",
              "lastName": "k",
              "email": "Matt@Kvg.com",
              "mobileNumber": "0457897887",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "e94e6405-21d5-4c94-a10b-75b138ff5c65",
      "eventName": "Science EXPO 120",
      "description": "testr",
      "eventTypeId": "9c668ef3-dff1-f011-8195-002248962eb2",
      "eventTypeName": "fte3tfg",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-28T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "d85c05ae-299d-f011-b483-000d3acacfee",
      "eventHostRegionName": "Sunshine Coast",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": "test",
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "f19ff5e7-6bf4-f011-832e-002248121f7b",
          "userId": "2cb6d09c-6439-46ef-1166-08de55b67c36",
          "firstName": "admin000000000000000000000000000000001",
          "lastName": "1",
          "email": "ishtechdeveloper10+admin1@gmail.com",
          "mobileNumber": "0423424234",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Nope",
      "participantsAndSupervisors": "23 studemt",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "693aff1b-ada2-4ac9-fab4-08de109ceaf5",
          "schoolName": "ABC school",
          "isMou": true,
          "teachers": [
            {
              "userId": "5d577cbd-6630-4620-0d2d-08de3df94b09",
              "firstName": "Jo",
              "lastName": "Smith",
              "email": "jo.smith+1@csq.org.au",
              "mobileNumber": "0455555555",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "910c437c-71d2-4451-9435-e26511a37ea9",
      "eventName": "Test Dup ",
      "description": "Test",
      "eventTypeId": "ef95ebf1-179d-f011-b483-000d3acacfee",
      "eventTypeName": "Hutchies Try A Trade",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-26T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "Brisbane",
      "audienceTypeId": "b9a21325-2baa-43a1-8d3d-12ef3d59fe55",
      "audienceTypeName": "Career Seekers",
      "eventHostRegionId": "d85c05ae-299d-f011-b483-000d3acacfee",
      "eventHostRegionName": "Sunshine Coast",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": "noep",
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_910c437c-71d2-4451-9435-e26511a37ea9_5be50ad1-2563-4eb9-a9a2-ca2a20982304.jpg",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_910c437c-71d2-4451-9435-e26511a37ea9_999b9b89-988f-4e94-bdd6-5f6764f4ec84.jpg"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "615fea83-9ac0-45de-62f9-08de3a14164e",
          "userId": "4b604008-b15e-44d7-870a-08de3a0dfbb5",
          "firstName": "SahalCSQAdmintest100",
          "lastName": "PS",
          "email": "sahal.g3interactive+Admincsq@gmail.com",
          "mobileNumber": "0469856974",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "31d68be0-3e4a-4cd8-b734-23d8b00cb3c3",
      "eventName": "Draft-Event-19",
      "description": "You’ve been added to the Construction Pathways Experience Portal.\r\nBelow are your login details to access your account:",
      "eventTypeId": "fae3c304-56cb-f011-8195-002248117e03",
      "eventTypeName": "Virtual Reality",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "1:20 AM to 3:21 PM",
      "location": "Brisbane",
      "audienceTypeId": "9f5e0d8a-3920-4937-be46-90c2be79cd48",
      "audienceTypeName": "G3 Team",
      "eventHostRegionId": "d85c05ae-299d-f011-b483-000d3acacfee",
      "eventHostRegionName": "Sunshine Coast",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_31d68be0-3e4a-4cd8-b734-23d8b00cb3c3_4b4bcd4f-54c1-4b11-ac12-9157615070ba.jpg",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_31d68be0-3e4a-4cd8-b734-23d8b00cb3c3_0beebcec-e4d4-4383-8a87-06a310740682.jpg",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_31d68be0-3e4a-4cd8-b734-23d8b00cb3c3_a087e091-d5d1-4ba3-8464-20baf77c1155.jpg"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "2a83c7ed-2399-41b9-db64-08de2b083748",
          "userId": "2bff575e-8f1a-4134-23cb-08de2ab5703d",
          "firstName": "Ranjeeta",
          "lastName": "Singh",
          "email": "ranjeeta.singh+9@csq.org.au",
          "mobileNumber": "0488888888",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Nope",
      "participantsAndSupervisors": "21 students",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "7559a60e-7fc3-4056-80bd-5a557b635395",
      "eventName": "savad new test",
      "description": "qawsedrfttgyh",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-28T00:00:00",
      "noOfDays": 0,
      "eventTime": "10:00AM to 7:04PM",
      "location": "sadasd",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "447dbfe0-1311-4d7e-8b6d-257254123600",
      "eventName": "Testevent17-01-2026",
      "description": "For Testing",
      "eventTypeId": "c148e9da-46f0-f011-8195-002248962eb2",
      "eventTypeName": "TestEventType13-01-2026",
      "eventStartDate": "2026-01-18T00:00:00",
      "eventEndDate": "2026-01-24T00:00:00",
      "noOfDays": 2,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "ab5a5245-aee7-4513-8c55-edcaab4666e4",
      "eventName": "Work Experience type check",
      "description": "Cabinetmaking",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-23T00:00:00",
      "noOfDays": 0,
      "eventTime": "10:00 AM to 7:08 PM",
      "location": "sadsadasd",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/teacher-events/teacher_event_ab5a5245-aee7-4513-8c55-edcaab4666e4_1354a60d-eaa8-43b4-bcdb-1970e06fae3c.png"
      ],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "39f42290-a99e-4da1-242d-08de1b8f4ae0",
              "firstName": "savad",
              "lastName": "Teacher",
              "email": "savad.g3interactive+teacher@gmail.com",
              "mobileNumber": "+61423456789",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "2782d4fa-388e-4325-ae3f-9a7916e5371e",
      "eventName": "qeqw",
      "description": null,
      "eventTypeId": "3cb45110-88ec-f011-8195-002248117e03",
      "eventTypeName": "Test 08-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-02-06T00:00:00",
      "noOfDays": 1,
      "eventTime": "1:44 PM to 5:48 PM",
      "location": "eq",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "237cd4a1-d0ed-f011-8193-00224891be99",
          "userId": "62ada717-92e5-432f-191e-08de4f61ce16",
          "firstName": "Anto",
          "lastName": "CSQ User 2",
          "email": "anto.g3interactive+CSQUser2@gmail.com",
          "mobileNumber": "+61 412345678",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "798fc964-529c-4b3e-a102-f71e3e256d24",
      "eventName": "ABC",
      "description": null,
      "eventTypeId": "c148e9da-46f0-f011-8195-002248962eb2",
      "eventTypeName": "TestEventType13-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-28T00:00:00",
      "noOfDays": 1,
      "eventTime": "1:01 AM to 12:12 PM",
      "location": "Test",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_798fc964-529c-4b3e-a102-f71e3e256d24_354cfce6-5551-4705-92db-6223da3a5cef.jpg"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "aef86627-9ab7-47d7-e8fd-08de1c5a38a6",
          "userId": "bd712dfb-1850-4f97-a23c-08de1c5a3887",
          "firstName": "Anna",
          "lastName": "Richardson",
          "email": "anna.richardson@csq.org.au",
          "mobileNumber": "0499999999",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": true,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "CSK",
      "participantsAndSupervisors": "16,2",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "c9aaed04-5c5c-4a38-7ad1-08de2e3b09c0",
          "schoolName": "AJS - Non-MOU",
          "isMou": false,
          "teachers": [
            {
              "userId": "101f081e-b574-4d1c-514a-08de2dbfac11",
              "firstName": "Anto",
              "lastName": "Non-MOU Teacher",
              "email": "anto.g3interactive+ajsnonmouteacher@gmail.com",
              "mobileNumber": "0454571765",
              "profilePicture": ""
            },
            {
              "userId": "224d2e2f-ccc6-41da-191d-08de4f61ce16",
              "firstName": "Anto",
              "lastName": "Non-MOU Teacher",
              "email": "anto.g3interactive+NonMOUTeacher@gmail.com",
              "mobileNumber": "0412345678",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "ee67d0a7-6f35-492c-a6c0-f13041ea2487",
      "eventName": "teacher-we-test-rejection",
      "description": "f49e9cfb-c899-4142-a64d-227a0412d90c",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-30T00:00:00",
      "noOfDays": 0,
      "eventTime": "6:56 PM to 8:56 PM",
      "location": "fffsdfds",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "1f13d5b7-18df-f011-8195-002248117e03",
          "schoolName": "CKD school",
          "isMou": true,
          "teachers": [
            {
              "userId": "7243be8d-dd65-43ce-a5a6-08de2822981d",
              "firstName": "Deep",
              "lastName": "Teacher",
              "email": "mandeep.singh+3@csq.org.au",
              "mobileNumber": "0400020021",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "7b34246a-4a34-46aa-a387-8910372c785f",
      "eventName": "Event Draft Test",
      "description": "Event Draft Test",
      "eventTypeId": "94bf38c6-57d9-f011-8195-002248117e03",
      "eventTypeName": "Points Farm",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-29T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:30 PM to 1:31 PM",
      "location": "Milton Park",
      "audienceTypeId": "d93dd561-3c67-43e5-bb95-6a2c118c472f",
      "audienceTypeName": "Sports Clubs",
      "eventHostRegionId": "532440b7-5862-47d8-8de5-3a56154f0db0",
      "eventHostRegionName": "Far North Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "f2b04414-49d8-40c1-9d36-b3fb3e19b8e8",
          "focusAreaName": "focus area",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "c348bb85-caf7-43cd-e627-08de1c0f35a5",
          "userId": "3fd72fcd-f1c2-4cb9-985f-08de1c0dbed7",
          "firstName": "Joseph",
          "lastName": "Wong",
          "email": "joseph.wong@csq.org.au",
          "mobileNumber": "+61 406197728",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "3fbd6e9a-5a92-4567-8769-48234dd2756f",
      "eventName": "PDP Farm",
      "description": null,
      "eventTypeId": "94bf38c6-57d9-f011-8195-002248117e03",
      "eventTypeName": "Points Farm",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-26T00:00:00",
      "noOfDays": 1,
      "eventTime": "2:33 PM to 2:33 AM",
      "location": "Milton Green",
      "audienceTypeId": "818cc19f-6aa1-4fbc-92ce-4047bda0cbe4",
      "audienceTypeName": "Students",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "f2b04414-49d8-40c1-9d36-b3fb3e19b8e8",
          "focusAreaName": "focus area",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "c348bb85-caf7-43cd-e627-08de1c0f35a5",
          "userId": "3fd72fcd-f1c2-4cb9-985f-08de1c0dbed7",
          "firstName": "Joseph",
          "lastName": "Wong",
          "email": "joseph.wong@csq.org.au",
          "mobileNumber": "+61 406197728",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "72a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Ongoing",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "a9f417ce-93dc-44e8-af84-0b40ca4d3e1d",
      "eventName": "Testevent12566",
      "description": "For testing",
      "eventTypeId": "fae3c304-56cb-f011-8195-002248117e03",
      "eventTypeName": "Virtual Reality",
      "eventStartDate": "2026-01-24T00:00:00",
      "eventEndDate": "2026-01-25T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 8:00 PM",
      "location": "Brisbane",
      "audienceTypeId": "f5cc1456-8e95-4f6d-aa94-f377ba00ad1d",
      "audienceTypeName": "Teachers",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": true,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "90ecae47-6bf7-f011-832e-002248121f7b",
          "focusAreaName": "test-9-10-2025 -",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "3c3800b8-dbd0-f011-8195-002248117e03",
          "userId": "e3f1c7b1-a62b-4cc8-9ab8-4487d03d2534",
          "firstName": "Ranjeeta",
          "lastName": "Singh (CSQ Admin)",
          "email": "ranjeeta.singh@csq.org.au",
          "mobileNumber": "0456789209",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": false,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "1382e93c-253d-4fc1-3244-08de33b3634d",
          "mccEventPartnerName": "Anto MCC Partner",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": true,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": "1212933655861234",
      "asanaLastSyncedAt": "2026-01-23T04:30:41.8474667",
      "asanaSyncedByUserName": "Sahal CSQAdmin",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "69eb4f59-1129-4201-8f8a-30878bba9aa3",
      "eventName": "Work Experience -  New Event Create",
      "description": null,
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 0,
      "eventTime": "1:01AM to 2:02AM",
      "location": "Test",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "0286abfb-2750-4060-8569-0a6fd9375be0",
      "eventName": "test",
      "description": null,
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-22T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 2,
      "eventTime": "9:40 PM to 6:43 PM",
      "location": "dfsgdsfg",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "490940d0-29f5-f011-832e-002248121f7b",
          "focusAreaName": "focusarea20-56-2035",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "5e8d8f72-15f2-f011-8195-002248962eb2",
          "userId": "e86a4ea4-c19b-4add-1eb5-08de542c8ee1",
          "firstName": "admin",
          "lastName": "1",
          "email": "ishtechdeveloper10+csqadmin@gmail.com",
          "mobileNumber": "0423424234",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "wer",
      "participantsAndSupervisors": "345",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "b8160ef2-de2f-43cc-a5a7-08de2822981d",
              "firstName": "sana",
              "lastName": "shukkur teacher",
              "email": "sana.g3interactive+teacher@gmail.com",
              "mobileNumber": "+61499123456",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "39d46a17-005c-4611-b710-0b593dafefd0",
          "mccEventPartnerName": "Testpartner18-01-2026",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "1346ef54-baa5-414a-8484-b1bafa706523",
      "eventName": "TestEvent20-01-20266",
      "description": "For Testing",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 9:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": true,
      "busRequired": true,
      "additionalRequirements": "Test",
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0a1e5737-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-55-2034",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        },
        {
          "focusAreaId": "490940d0-29f5-f011-832e-002248121f7b",
          "focusAreaName": "focusarea20-56-2035",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "3c3800b8-dbd0-f011-8195-002248117e03",
          "userId": "e3f1c7b1-a62b-4cc8-9ab8-4487d03d2534",
          "firstName": "Ranjeeta",
          "lastName": "Singh (CSQ Admin)",
          "email": "ranjeeta.singh@csq.org.au",
          "mobileNumber": "0456789209",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": true,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        },
        {
          "schoolId": "4e664f12-3b6d-4dab-5eeb-08de2d9ed2a6",
          "schoolName": "TestSchoolNONMOU",
          "isMou": false,
          "teachers": [
            {
              "userId": "823928a7-ccb5-42bd-6d37-08de3070daaa",
              "firstName": "Marsha",
              "lastName": "Swank",
              "email": "marsha.schwenke+1@csq.org.au",
              "mobileNumber": "0499999999",
              "profilePicture": ""
            },
            {
              "userId": "9185a725-0a2a-4db3-513e-08de2dbfac11",
              "firstName": "TestTeacherNonmouCKD",
              "lastName": "PS",
              "email": "sahal.g3interactive+nonmouteacher1@gmail.com",
              "mobileNumber": "0465968569",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "39d46a17-005c-4611-b710-0b593dafefd0",
          "mccEventPartnerName": "Testpartner18-01-2026",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        },
        {
          "mccEventPartnerId": "b38fb8ac-70f2-4924-829f-fc5f6bba39d8",
          "mccEventPartnerName": "testpa9",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": true,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": "1212824092756648",
      "asanaLastSyncedAt": "2026-01-20T12:03:38.9357607",
      "asanaSyncedByUserName": "Sahal CSQAdmin",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "364bcb77-af6a-4522-9531-7cd87a060cad",
      "eventName": "CSQ User event",
      "description": null,
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "dwd",
      "audienceTypeId": "47e1937a-30f9-48c6-b099-db7540a6e873",
      "audienceTypeName": "testaudience71202600",
      "eventHostRegionId": "d85c05ae-299d-f011-b483-000d3acacfee",
      "eventHostRegionName": "Sunshine Coast",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "5e8d8f72-15f2-f011-8195-002248962eb2",
          "userId": "e86a4ea4-c19b-4add-1eb5-08de542c8ee1",
          "firstName": "admin",
          "lastName": "1",
          "email": "ishtechdeveloper10+csqadmin@gmail.com",
          "mobileNumber": "0423424234",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "test",
      "participantsAndSupervisors": "ws",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "693aff1b-ada2-4ac9-fab4-08de109ceaf5",
          "schoolName": "ABC school",
          "isMou": true,
          "teachers": [
            {
              "userId": "4901d75a-570f-4060-6d32-08de3070daaa",
              "firstName": "Sarah",
              "lastName": "hehehehe",
              "email": "caitlin.belgrove+1@csq.org.au",
              "mobileNumber": "0429158134",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "e7a0326d-acd5-4922-bbbc-a5e8da0ba963",
      "eventName": "TestEvent222",
      "description": "For Testing",
      "eventTypeId": "67f58af9-d7f5-f011-832e-002248121f7b",
      "eventTypeName": "Eventtype20-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 4:22 AM",
      "location": "Brisbane",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "490940d0-29f5-f011-832e-002248121f7b",
          "focusAreaName": "focusarea20-56-2035",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "1f939cb0-69e5-f011-8195-002248117e03",
          "userId": "e926ee36-8b22-41bb-5360-08de478d955f",
          "firstName": "SahalCSQUSer",
          "lastName": "RS",
          "email": "sahal.g3interactive+SahalCSQUSer@gmail.com",
          "mobileNumber": "0489652369",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "651742fe-1f40-48a2-a161-b8b808d0e08a",
      "eventName": "Work Experience020",
      "description": "For Testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 1:00AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "03f55bb9-973f-47a6-aecd-ff1f9f2db740",
      "eventName": "Work Experience-100-testing",
      "description": null,
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 2,
      "eventTime": "11:57AM to 11:57AM",
      "location": "Work Experience-100-testing",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "d8fe791d-4673-4d94-8f44-d43fc9030031",
      "eventName": "Work Experience20-01-2026",
      "description": "for testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 4:04AM",
      "location": "brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "18fcd331-e2a8-45a3-92b4-f3632796092b",
      "eventName": "Work Experience-test",
      "description": null,
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "11:29AM to 2:27PM",
      "location": "location",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "d2a1da2e-0ec1-418e-bd46-2390431b4166",
      "eventName": "Work Experience",
      "description": null,
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 2,
      "eventTime": "11:49AM to 12:49PM",
      "location": "test",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "dd16d79a-f390-433d-81fe-028ad0aa7efa",
      "eventName": "Work Experience-testing-100",
      "description": null,
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:16PM to 12:16PM",
      "location": "test",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "df156af6-8b34-4b5d-be31-a016b054f678",
      "eventName": "TestEvent20-01-2026",
      "description": "For Testing",
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": true,
      "busRequired": true,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "bd981f21-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focus area 8-2-2026",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "275d0333-eb7a-4a2b-860f-af08dd06c576",
      "eventName": "Work Experience20-01-2026",
      "description": "Cabinetmaking",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 9:00 AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "40def54e-8e64-4f54-9252-d7378b1e62bf",
      "eventName": "test",
      "description": "test",
      "eventTypeId": "c148e9da-46f0-f011-8195-002248962eb2",
      "eventTypeName": "TestEventType13-01-2026",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "5:41 PM to 6:41 PM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0a1e5737-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-55-2034",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "aef86627-9ab7-47d7-e8fd-08de1c5a38a6",
          "userId": "bd712dfb-1850-4f97-a23c-08de1c5a3887",
          "firstName": "Anna",
          "lastName": "Richardson",
          "email": "anna.richardson@csq.org.au",
          "mobileNumber": "0499999999",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "no",
      "participantsAndSupervisors": "noi",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "39f42290-a99e-4da1-242d-08de1b8f4ae0",
              "firstName": "savad",
              "lastName": "Teacher",
              "email": "savad.g3interactive+teacher@gmail.com",
              "mobileNumber": "+61423456789",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "1ae88805-c4fe-4278-8d39-a0ef7b9569fe",
      "eventName": "TEst 124",
      "description": null,
      "eventTypeId": "f095ebf1-179d-f011-b483-000d3acacfee",
      "eventTypeName": "WorldSkills Try A Trade",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "Brisbane",
      "audienceTypeId": "b9a21325-2baa-43a1-8d3d-12ef3d59fe55",
      "audienceTypeName": "Career Seekers",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "a8eaf1f1-51ec-f011-8195-002248117e03",
          "userId": "8b19db86-01c3-45c9-9d83-08de4de11ee4",
          "firstName": "mohammad",
          "lastName": "savad",
          "email": "savad.g3interactive+csqadmin1@gmail.com",
          "mobileNumber": "+61452452452",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "test",
      "participantsAndSupervisors": "20 test",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "695adbec-7aed-4ed6-79a7-08de31706810",
          "schoolName": "Joseph Senior High",
          "isMou": true,
          "teachers": [
            {
              "userId": "f8f11060-63f2-4a2d-3718-08de2a6b4361",
              "firstName": "Markw",
              "lastName": "Thompson",
              "email": "jaisaran.g3interactive+12345@gmail.com",
              "mobileNumber": "0482930333",
              "profilePicture": "https://storcsqtrexdev.blob.core.windows.net/trex-images/profile-pictures/33dd91cb-c806-4b98-8239-15f4e2e6d5e6.jpg"
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "242e99d9-dd6e-4f41-a2b9-26a6e0984b1b",
      "eventName": "draft event-2",
      "description": null,
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "2:00 PM to 3:00 PM",
      "location": "erder",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0a1e5737-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-55-2034",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "f19ff5e7-6bf4-f011-832e-002248121f7b",
          "userId": "2cb6d09c-6439-46ef-1166-08de55b67c36",
          "firstName": "admin000000000000000000000000000000001",
          "lastName": "1",
          "email": "ishtechdeveloper10+admin1@gmail.com",
          "mobileNumber": "0423424234",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "5e558176-53a6-40e2-bb9d-59dd6167595d",
      "eventName": "Testevent18-01-2026",
      "description": "For testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-20T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 1:00AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "67de3a8a-ea7e-4360-8ee5-58c5b016f6db",
      "eventName": "TestEvent888",
      "description": "For Testing44",
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:11 AM",
      "location": "brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0a1e5737-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focusarea9-55-2034",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "p",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "a7966b84-e841-48d1-9cb6-750cfd25799d",
      "eventName": "TestEvent18801",
      "description": "For testing",
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-20T00:00:00",
      "eventEndDate": "2026-01-22T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 6:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "9ba01534-42ed-4462-a035-65a48398507d",
      "audienceTypeName": "ww",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "e31301fd-47a5-462a-9f60-ca4938fecc80",
      "eventName": "TestEvent1888",
      "description": "For Testing",
      "eventTypeId": "52496c4a-39f4-f011-832e-002248121f7b",
      "eventTypeName": "TestEventtype18-01-2026",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-20T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 6:06 AM",
      "location": "brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "bd981f21-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focus area 8-2-2026",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "",
      "participantsAndSupervisors": "",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "7e75b52a-a0fa-4601-b72a-c4e51483bfb7",
      "eventName": "Testevent0018-01-2026",
      "description": null,
      "eventTypeId": "c148e9da-46f0-f011-8195-002248962eb2",
      "eventTypeName": "TestEventType13-01-2026",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_7e75b52a-a0fa-4601-b72a-c4e51483bfb7_7d63c537-25f5-445b-9e9c-044d079a7f46.png",
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_7e75b52a-a0fa-4601-b72a-c4e51483bfb7_2402a6e9-5d6a-4937-96e5-b4767be1f0f4.jpg"
      ],
      "focusAreas": [
        {
          "focusAreaId": "bd981f21-3ff4-f011-832e-002248121f7b",
          "focusAreaName": "focus area 8-2-2026",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "39d46a17-005c-4611-b710-0b593dafefd0",
          "mccEventPartnerName": "Testpartner18-01-2026",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "799e331a-28ed-4ba7-ba0e-3426926bfed5",
      "eventName": "CSQ Event18-01-2026",
      "description": null,
      "eventTypeId": "c148e9da-46f0-f011-8195-002248962eb2",
      "eventTypeName": "TestEventType13-01-2026",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-20T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": true,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": true,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": true,
      "collaborationType": 1,
      "collaborationTypeName": "MccPartners",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        },
        {
          "schoolId": "4e664f12-3b6d-4dab-5eeb-08de2d9ed2a6",
          "schoolName": "TestSchoolNONMOU",
          "isMou": false,
          "teachers": [
            {
              "userId": "9185a725-0a2a-4db3-513e-08de2dbfac11",
              "firstName": "TestTeacherNonmouCKD",
              "lastName": "PS",
              "email": "sahal.g3interactive+nonmouteacher1@gmail.com",
              "mobileNumber": "0465968569",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [
        {
          "mccEventPartnerId": "3ab68bbf-c8a9-4eb6-7465-08de1d041bd6",
          "mccEventPartnerName": "testpartner",
          "contactName": null,
          "contactEmail": null,
          "contactPhone": null,
          "engagementCount": 0,
          "status": "Inactive"
        }
      ],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "df03d020-6d39-4f92-914c-ac17d640d33a",
      "eventName": "Work Experience",
      "description": "Bricklaying",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-20T00:00:00",
      "noOfDays": 1,
      "eventTime": "3:24 AM to 4:24 AM",
      "location": "test",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "2dee1aed-f088-4cee-7ad0-08de2e3b09c0",
          "schoolName": "AJS - MOU",
          "isMou": true,
          "teachers": [
            {
              "userId": "b8160ef2-de2f-43cc-a5a7-08de2822981d",
              "firstName": "sana",
              "lastName": "shukkur teacher",
              "email": "sana.g3interactive+teacher@gmail.com",
              "mobileNumber": "+61499123456",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "acda7282-8776-44f3-b6e1-ea7213cd02cc",
      "eventName": "External event17-01-2026",
      "description": "For testing",
      "eventTypeId": "9dc23366-c6c5-f011-8195-002248117e03",
      "eventTypeName": "Student External Event",
      "eventStartDate": "2026-01-18T00:00:00",
      "eventEndDate": "2026-01-19T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00PM to 1:00AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "ace6a984-71c7-f011-8195-002248117e03",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "364d9195-6348-459e-a900-4e54f2c0ced3",
      "eventName": "Work Experience0017-01-2026",
      "description": "f49e9cfb-c899-4142-a64d-227a0412d90c",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-18T00:00:00",
      "eventEndDate": "2026-01-19T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:11 AM",
      "location": "Brisbaane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "5d2888c7-bbcd-4343-a4a2-760e5343c4cf",
      "eventName": "Work Experience17-01-2026",
      "description": "f8b52b6f-c9bb-4514-92e6-d36110caedde",
      "eventTypeId": "c3f8117f-c5c5-f011-8195-002248117e03",
      "eventTypeName": "Teacher Work Experience",
      "eventStartDate": "2026-01-18T00:00:00",
      "eventEndDate": "2026-01-19T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 11:11 AM",
      "location": "Brisbane",
      "audienceTypeId": null,
      "audienceTypeName": "",
      "eventHostRegionId": null,
      "eventHostRegionName": "",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [],
      "managers": [],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d7f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "18f4190e-a5b6-469a-8865-6916e5cbf98c",
      "eventName": "Testeventdraft17-01-2026",
      "description": "For Testing",
      "eventTypeId": "a2df1318-22ed-f011-8195-002248117e03",
      "eventTypeName": "Perdaytest",
      "eventStartDate": "2026-01-18T00:00:00",
      "eventEndDate": "2026-01-19T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "brisbane",
      "audienceTypeId": "47e1937a-30f9-48c6-b099-db7540a6e873",
      "audienceTypeName": "testaudience71202600",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [
        "https://storcsqtrexdev.blob.core.windows.net/trex-images/event-images/event_18f4190e-a5b6-469a-8865-6916e5cbf98c_75612fe4-9cb1-460f-bd49-26675bd322ee.png"
      ],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "237cd4a1-d0ed-f011-8193-00224891be99",
          "userId": "62ada717-92e5-432f-191e-08de4f61ce16",
          "firstName": "Anto",
          "lastName": "CSQ User 2",
          "email": "anto.g3interactive+CSQUser2@gmail.com",
          "mobileNumber": "+61 412345678",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": true,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "0ebf7276-2666-46c6-9c12-08de2b0d6fce",
              "firstName": "TestteacherCKD",
              "lastName": "psss",
              "email": "sahal.g3interactive+teacherCKD@gmail.com",
              "mobileNumber": "0465689658",
              "profilePicture": ""
            }
          ]
        },
        {
          "schoolId": "4e664f12-3b6d-4dab-5eeb-08de2d9ed2a6",
          "schoolName": "TestSchoolNONMOU",
          "isMou": false,
          "teachers": [
            {
              "userId": "9185a725-0a2a-4db3-513e-08de2dbfac11",
              "firstName": "TestTeacherNonmouCKD",
              "lastName": "PS",
              "email": "sahal.g3interactive+nonmouteacher1@gmail.com",
              "mobileNumber": "0465968569",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "b73d01f4-e036-48b3-8e61-38f487a1950d",
      "eventName": "Testnew1601",
      "description": null,
      "eventTypeId": "94bf38c6-57d9-f011-8195-002248117e03",
      "eventTypeName": "Points Farm",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-20T00:00:00",
      "noOfDays": 2,
      "eventTime": "10:00 AM to 8:00 PM",
      "location": "qwertyudfghnjm,",
      "audienceTypeId": "818cc19f-6aa1-4fbc-92ce-4047bda0cbe4",
      "audienceTypeName": "Students",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "21313edb-6bf0-f011-8195-002248962eb2",
          "userId": "07c92284-0849-45b5-3df6-08de528fc312",
          "firstName": "Namitha",
          "lastName": "MV",
          "email": "namitha.g3interactive+admintest1301@gmail.com",
          "mobileNumber": "0412533633",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "07e26b72-f4cf-4d48-a89d-42fc742361ec",
      "eventName": "TestEvent16-01-2026",
      "description": "For testing",
      "eventTypeId": "a2df1318-22ed-f011-8195-002248117e03",
      "eventTypeName": "Perdaytest",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-19T00:00:00",
      "noOfDays": 1,
      "eventTime": "12:00 PM to 1:00 AM",
      "location": "Brisbane",
      "audienceTypeId": "abcec9bd-d638-4313-a619-0cb59230b3cb",
      "audienceTypeName": "test types",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "0f5d3dd7-9bfd-4868-3c8c-08de30b3eaa0",
          "userId": "e95b4451-2f06-49f3-27b9-08de30af3155",
          "firstName": "Sahal",
          "lastName": "CSQAdmin",
          "email": "sahal.g3interactive+CSQadmin@gmail.com",
          "mobileNumber": "0465789510",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "Sports",
      "participantsAndSupervisors": "5",
      "isCsqFunded": true,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "ee37b23a-d8ce-40f8-193e-08de2b0ff04e",
          "schoolName": "TestSchoolCKD",
          "isMou": true,
          "teachers": [
            {
              "userId": "5bc6ebac-6374-43be-b8e5-08de5484bc45",
              "firstName": "Testteacher16-01-2026",
              "lastName": "PS",
              "email": "sahal.g3interactive+testteacher16-01-2026@gmail.com",
              "mobileNumber": "0489652369",
              "profilePicture": "https://storcsqtrexdev.blob.core.windows.net/trex-images/profile-pictures/ccdbe15f-048f-4c46-bd20-492dc8ca190e.png"
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "e579c9a2-eb37-45d9-b731-43313d2a1816",
      "eventName": "test",
      "description": "ksadnfksndfnskdfknsa fkna ",
      "eventTypeId": "c148e9da-46f0-f011-8195-002248962eb2",
      "eventTypeName": "TestEventType13-01-2026",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "",
      "location": "test",
      "audienceTypeId": "69c4c03f-02a1-4a06-90d5-65a02923dd84",
      "audienceTypeName": "What is this",
      "eventHostRegionId": "a3b834c9-059a-4506-9179-428fff88110a",
      "eventHostRegionName": "Marthandam",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0298e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Residential",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "237cd4a1-d0ed-f011-8193-00224891be99",
          "userId": "62ada717-92e5-432f-191e-08de4f61ce16",
          "firstName": "Anto",
          "lastName": "CSQ User 2",
          "email": "anto.g3interactive+CSQUser2@gmail.com",
          "mobileNumber": "+61 412345678",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": false,
      "nonMouReason": null,
      "careerSeekerOrgsOrSportsClubs": null,
      "participantsAndSupervisors": null,
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": null,
      "collaborationTypeName": null,
      "collaboratingWithNonMcc": null,
      "schools": [],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "bee682f8-cb56-4526-bd40-5d1b69db34cc",
      "eventName": "Testnew13012026",
      "description": null,
      "eventTypeId": "12a720b7-b8e0-f011-8195-002248117e03",
      "eventTypeName": "dub test5",
      "eventStartDate": "2026-01-19T00:00:00",
      "eventEndDate": "2026-01-19T00:00:00",
      "noOfDays": 1,
      "eventTime": "5:00 AM to 7:00 PM",
      "location": "dfhbgnxgfnbbb",
      "audienceTypeId": "818cc19f-6aa1-4fbc-92ce-4047bda0cbe4",
      "audienceTypeName": "Students",
      "eventHostRegionId": "57f877e1-f5bc-4e52-bc7f-1ec6815c5188",
      "eventHostRegionName": "Central Queensland",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "738fb6c7-19ed-f011-8195-002248117e03",
          "focusAreaName": "Testing123",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "60a8041f-b586-430a-37f2-08de2d7fa3f3",
          "userId": "be1d9611-f29e-4046-8c7d-08de2d7fa3e6",
          "firstName": "Namitha",
          "lastName": "MV",
          "email": "namitha.g3interactive+csq@gmail.com",
          "mobileNumber": "0425478963",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": true,
      "nonMouSchoolsAttending": false,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "tggb",
      "participantsAndSupervisors": "6",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "dc8f72e5-3b0f-4ffd-3f5d-08de2c15f429",
          "schoolName": "TestSchool",
          "isMou": true,
          "teachers": [
            {
              "userId": "4c5dead5-696d-44d2-5af9-08de2cb16c27",
              "firstName": "Namitha",
              "lastName": "MV",
              "email": "namitha.g3interactive+teacher@gmail.com",
              "mobileNumber": "9745465535",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    },
    {
      "eventId": "de3bbadf-56a0-4b71-a86b-e3b242c66c27",
      "eventName": "Test - To show in student portal.",
      "description": null,
      "eventTypeId": "3f825179-66e5-f011-8195-002248117e03",
      "eventTypeName": "TX",
      "eventStartDate": "2026-01-21T00:00:00",
      "eventEndDate": "2026-01-21T00:00:00",
      "noOfDays": 1,
      "eventTime": "1:47 PM to 3:47 PM",
      "location": "HQ",
      "audienceTypeId": "818cc19f-6aa1-4fbc-92ce-4047bda0cbe4",
      "audienceTypeName": "Students",
      "eventHostRegionId": "683dcd5f-63f0-4fb8-962b-1472971c5468",
      "eventHostRegionName": "Metropolitan",
      "cateringRequired": false,
      "busRequired": false,
      "additionalRequirements": null,
      "imagePaths": [],
      "focusAreas": [
        {
          "focusAreaId": "0398e46d-139d-f011-b483-000d3acacfee",
          "focusAreaName": "Commercial",
          "focusAreaDescription": null,
          "focusAreaEngagementCount": 0,
          "status": "Pending"
        }
      ],
      "managers": [
        {
          "memberId": "aef86627-9ab7-47d7-e8fd-08de1c5a38a6",
          "userId": "bd712dfb-1850-4f97-a23c-08de1c5a3887",
          "firstName": "Anna",
          "lastName": "Richardson",
          "email": "anna.richardson@csq.org.au",
          "mobileNumber": "0499999999",
          "secondaryEmail": null,
          "status": "Pending",
          "isCSQAdmin": false,
          "profilePicture": ""
        }
      ],
      "mouSchoolsAttending": false,
      "nonMouSchoolsAttending": true,
      "nonMouReason": "",
      "careerSeekerOrgsOrSportsClubs": "na",
      "participantsAndSupervisors": "23",
      "isCsqFunded": false,
      "collaborating": false,
      "collaborationType": 0,
      "collaborationTypeName": "0",
      "collaboratingWithNonMcc": "",
      "schools": [
        {
          "schoolId": "60463929-c609-4ea3-9b78-08de2a74a308",
          "schoolName": "Brisbane State High School",
          "isMou": false,
          "teachers": [
            {
              "userId": "c2d9881c-ca4d-44db-6d34-08de3070daaa",
              "firstName": "MatilTeach",
              "lastName": "Fos",
              "email": "mathilda.foster+1@csq.org.au",
              "mobileNumber": "0432694877",
              "profilePicture": ""
            }
          ]
        }
      ],
      "mccPartners": [],
      "isDraft": false,
      "eventStatusId": "73a05785-89bb-f011-8195-000d3a6b13e5",
      "eventStatus": "Already Held",
      "isSyncedWithAsana": false,
      "eventTypeScopeId": "d6f7150e-e4be-f011-8195-000d3a6b13e5",
      "eventTypeScopeName": "",
      "eventAdminApprovalStatusName": "",
      "eventAdminApprovalComment": "",
      "eventTeacherApprovalStatusName": null,
      "eventTeacherApprovalComment": null,
      "asanaTaskGid": null,
      "asanaLastSyncedAt": null,
      "asanaSyncedByUserName": "",
      "createdBy": "00000000-0000-0000-0000-000000000000",
      "createdByRole": "",
      "parentGuardianEmails": [],
      "studentCount": 0,
      "teacherName": null
    }
  ]
}
